import React, { createContext, useState, useContext, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { clearSession, getRefreshToken, getStoredUser, getToken, setSession } from '../lib/storage';
import api from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = getToken();
        const savedUser = getStoredUser();
        if (token) {
            try {
                const decoded = jwtDecode(token);
                if (decoded.exp * 1000 > Date.now()) {
                    if (savedUser) {
                        setUser(savedUser);
                    } else {
                        setUser({ id: decoded.user_id, role: decoded.role });
                    }
                } else {
                    clearSession();
                }
            } catch (error) {
                clearSession();
            }
        }
        setLoading(false);
    }, []);

    const login = (token, refreshToken, userData) => {
        setSession(token, refreshToken, userData);
        setUser(userData);
    };

    const logout = async () => {
        const refreshToken = getRefreshToken();
        try {
            // Best-effort server-side revocation; never block logout on it.
            await api.post('/auth/logout', refreshToken ? { refresh_token: refreshToken } : {});
        } catch {
            // ignore network/revocation errors on logout
        }
        clearSession();
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, login, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
